/** Shopify CDN: Minification failed

Line 37:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 41:45 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 45:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 26:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 27:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 29:45 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 14:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 15:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:45 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 21:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 24:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $hover } = await importModule('Utils');

    customElements.define('main-navigation', class extends Core {
        elements = {
            dropdowns: '*[data-drop]'
        }
        render() {
            this.$dropdowns.map(this._handleDropdown.bind(this))
        }
        _handleDropdown(drop) {
            $hover(drop, (e, state) => this.publish('lights-out', state));
        }
    });
})();